<template>
  <!-- 弹窗 -->
  <el-dialog
    :visible.sync="dialogVisible"
    :title="dialogTitle"
    width="590px"
    :close-on-click-modal="false"
    custom-class="student-dialog"
    @close="handleDialogClose"
  >
    <div class="dialog-content">
      <!-- 表格头部 -->
      <div class="table-header">
        <div class="header-cell index-header">序号</div>
        <div class="header-cell time-header">学生答案</div>
        <div class="header-cell course-header">正确答案</div>
        <div class="header-cell progress-header">单题用时</div>
      </div>
      <!-- 表格内容 -->
      <div class="student-table-body">
        <template v-if="tableData.length">
          <div
            v-for="(item, index) in tableData"
            :key="index"
            class="student-table-row"
          >
            <div class="row-content">
              <div class="data-cell index-cell">
                {{ index + 1 }}
              </div>
              <div class="data-cell time-cell">
                {{ item.user_answer || "-" }}
              </div>
              <div class="data-cell course-cell">
                {{ item.right_option || "-" }}
              </div>
              <div class="data-cell progress-cell">
                {{ formatTimeBySecond(item.answer_time) }}
              </div>
            </div>
          </div>
        </template>
        <el-empty
          v-else
          description="暂无内容"
          :image="require('@/assets/img/live-list/empty.png')"
        ></el-empty>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <div class="pagination">
          <button
            class="pagination-btn prev"
            :class="{ disabled: currentPage === 1 }"
            :disabled="currentPage === 1"
            @click="handlePrevPage"
          >
            <img
              src="@saas/pages/assets/images/live-data/arrow-right.svg"
              alt="上一页"
            />
          </button>
          <div class="pagination-info">
            <span class="current-page">{{ currentPage }}</span>
            <span class="separator">/</span>
            <span class="total-pages">{{ totalPages }}</span>
          </div>
          <button
            class="pagination-btn next"
            :class="{ disabled: currentPage === 1 }"
            :disabled="currentPage === totalPages"
            @click="handleNextPage"
          >
            <img
              src="@saas/pages/assets/images/live-data/arrow-right.svg"
              alt="下一页"
            />
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getStudentAnswerDetail } from "@saas/service-api/src/live-data";
import { formatTimeBySecond } from "@saas/components/src";
// 引入 echarts 核心模块
import * as echarts from "echarts/core";
// 引入饼图图表
import { PieChart } from "echarts/charts";
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件
import { TooltipComponent, LegendComponent } from "echarts/components";
// 标签自动布局、全局过渡动画等特性
import { LabelLayout } from "echarts/features";
// 引入 Canvas 渲染器
import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);

export default {
  name: "ClickerDataDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    liveReport: {
      type: Object,
      default: () => {},
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      formatTimeBySecond,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.currentPage = 1;
          this.total = 0;
          this.getStudentAnswerDetail();
        }
      },
      immediate: true,
    },
  },
  computed: {
    dialogTitle() {
      return `${this.studentInfo.nickname} ${this.formatTimeBySecond(
        this.studentInfo.total_time
      )}`;
    },
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
  },
  methods: {
    // 获取学生答题统计
    getStudentAnswerDetail() {
      getStudentAnswerDetail({
        room_id: this.liveReport.room_id,
        user_id: this.studentInfo.user_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = [...res.data.list];
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleDialogClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    handleTabChange(tab) {
      this.activeTab = tab;
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getStudentAnswerDetail();
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getStudentAnswerDetail();
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
// 弹窗样式
::v-deep .student-dialog {
  width: 590px;
  height: 615px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    padding: 24px 24px 0 24px;
    border-bottom: none;
    position: relative;
    font-size: 16px;
    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      height: 22px;
      line-height: 22px;
      display: inline-block;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 22px;
      width: 24px;
      height: 24px;
      background: transparent;
      border: none;

      .el-dialog__close {
        color: #4e5969;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding: 0 24px 24px;
    flex: 1;
    overflow: hidden;
  }
}

.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .table-header {
    margin-top: 16px;
    display: flex;
    padding: 0 19px;
    height: 33px;
    line-height: 33px;
    .header-cell {
      font-size: 12px;
      color: #515350;
      font-weight: 400;
      flex: 1;
      &.time-header,
      &.course-header {
        text-align: right;
      }
      &.progress-header {
        flex: 2;
        text-align: right;
      }
      &.index-header {
        width: 45px;
        text-align: left;
        flex: none;
      }
    }
  }

  .student-table-body {
    flex: 1;
    overflow: auto;
    .student-table-row {
      margin-bottom: 8px;
      padding: 0 19px;
      background: #f7f8fa;
      border-radius: 12px;
      &:nth-of-type(even) {
        background: #fff;
      }
      .row-content {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        width: 100%;

        .data-cell {
          font-weight: 400;
          font-size: 14px;
          color: #1d2129;
          text-align: right;
          text-align: right;
          flex: 1;
        }
        .index-cell {
          width: 45px;
          text-align: left;
          flex: none;
        }
        .progress-cell {
          flex: 2;
        }
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: right;
    margin-top: 20px;

    .pagination {
      display: flex;
      align-items: center;
      gap: 4px;

      .pagination-btn {
        width: 20px;
        height: 32px;
        border: none;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
        padding: 8px 0;
        &.prev {
          transform: rotate(180deg);
        }
        &:hover:not(:disabled) {
          background: #fff;
        }

        &:disabled {
          background: #fff;
          cursor: not-allowed !important;
          img {
            opacity: 0.5;
          }
        }

        img {
          width: 12px;
          height: 12px;
        }
      }

      .pagination-info {
        display: flex;
        align-items: center;
        padding: 0 8px;
        font-size: 14px;
        color: #1d2129;
        line-height: 1.57;

        .current-page {
          width: 40px;
          height: 28px;
          font-weight: 600;
          font-size: 14px;
          color: #4e5969;
          line-height: 28px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
        }

        .separator {
          margin: 0 8px;
        }

        .total-pages {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
